import {RemotePostRecoverFile} from 'data/usecases/private/authorizations';
import {PostRecoverFile} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../../endpoints';

export const makePostRecoverFile = (): PostRecoverFile =>
	new RemotePostRecoverFile(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.recoverFile),
		makeAuthorizeHttpClientDecorator(),
	);
